<style lang="scss" scoped>
.image-message-element__image {
  max-width: 250px;

  img {
    max-width: 100%;
  }

  .no-image {
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 250px;
    height: 250px;
  }
}

.invalid-feedback {
  display: block;
}
</style>

<template>
  <div>
    <div class="rounded bg-secondary image-message-element__image">
      <img v-if="previewImage" :src="previewImage" />
      <div class="no-image" v-else>
        Kein Bild ausgewählt
      </div>
    </div>
    <div @click="openImageInput" class="btn btn-secondary">
      Bild auswählen
    </div>
    <input
      @input="emitImage"
      class="d-none"
      type="file"
      accept="image/*"
      ref="image-input"
    />
    <div
      v-if="hasErrors"
      v-for="(error, index) in attributeErrors"
      :key="index"
      class="invalid-feedback"
    >
      <div v-for="e in error" :key="e">
        {{ e }}
      </div>
    </div>
  </div>
</template>

<script lang="babel">
import GiftSelect from '@/components/GiftSelect.vue';

export default {
  components: {
    GiftSelect
  },
  props: {
    value: {
      required: true,
    },
    attributeErrors: {
      type: Array
    },
    id: {
      required: false,
      type: Number
    }
  },
  data() {
    return {
      previewImage: null
    };
  },
  computed: {
    hasErrors() {
      return this.attributeErrors !== null && this.attributeErrors.length !== 0;
    }
  },
  methods: {
    emitImage(event) {
      this.$emit('input', event.target.files[0]);
    },
    openImageInput() {
      this.$refs['image-input'].click();
    },
    setPreviewImage() {
      if (!this.value) {
        this.previewImage = null;
        return;
      }

      if (typeof this.value === 'number') {
        this.previewImage = `/api/v1/circularMail/media/${this.value}`;
        return;
      }

      let reader = new FileReader();

      reader.onload = (e) => {
        this.previewImage = e.target.result;
      };

      reader.readAsDataURL(this.value);
    }
  },
  created() {
    this.setPreviewImage();
  },
  watch: {
    value() {
      this.setPreviewImage();
    }
  }
}
</script>
